function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import iamFormElement from 'scripts/classes/iamFormElement';
import iamCartUndoItem from './cart-undo__item';
import Debug from 'scripts/libs/debug';

// Styles
import './_cart-undo.scss';

// Elements

class iamCartUndo extends iamFormElement {
  /**
   * Initialize the component when the product form is initialized
   */
  onFormInit() {
    this.allowMultiple = this.getAttribute('multiple') === 'true'; // Allow multiple undo messages?

    // Bind Event Listeners
    iamotaEventHandler.subscribe('cartForm:items:item:remove:removed', this.addUndoItem.bind(this), {
      source: "cart-undo.js"
    });
  }

  /**
   * Add an "undo item"
   */
  addUndoItem(_ref) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var _cachedCartItem$produ;
      var {
        cachedCartItem
      } = _ref;
      // Don't add items that aren't available for sale
      if (!((_cachedCartItem$produ = cachedCartItem.productData) !== null && _cachedCartItem$produ !== void 0 && (_cachedCartItem$produ = _cachedCartItem$produ.variant) !== null && _cachedCartItem$produ !== void 0 && (_cachedCartItem$produ = _cachedCartItem$produ.base) !== null && _cachedCartItem$produ !== void 0 && _cachedCartItem$produ.available)) {
        Debug.message('Cart Undo: Item not being added to undo list because it\'s not available for sale', cachedCartItem);
        return Promise.resolve(); // Ensure the caller can await this
      }

      // Don't add items that have been rejected by custom logic filters
      cachedCartItem = iamotaEventHandler.applyFiltersSync('cartForm:items:item:undo:adding', cachedCartItem, {
        context: _this.iamForm
      });
      if (!cachedCartItem) {
        Debug.message('Cart Undo: Item not being added to undo list because a filter denied it', cachedCartItem);
        return Promise.resolve(); // Ensure the caller can await this
      }

      // Clear existing items if "allowMultiple" isn't enabled
      if (!_this.allowMultiple) _this.innerHTML = '';

      // Create a new undo item
      var undoItem = new iamCartUndoItem(cachedCartItem);
      if (undoItem.cartItem) {
        _this.appendChild(undoItem);
      }
      return Promise.resolve();
    })();
  }
}
customElements.define('iam-cart-undo', iamCartUndo);